import { render, staticRenderFns } from "./CardBovines.vue?vue&type=template&id=5cc688f7&scoped=true"
import script from "./CardBovines.vue?vue&type=script&lang=js"
export * from "./CardBovines.vue?vue&type=script&lang=js"
import style0 from "./CardBovines.vue?vue&type=style&index=0&id=5cc688f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc688f7",
  null
  
)

export default component.exports